import * as React from 'react'
import { withStatus } from '../status'
import { replace } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import errorsActions from './errors-actions'

/*

Handles error state. The error state maps directly to fields. 

Example error state:

errors: {
    firstName: [
        'Please enter your first name.'
    ],
    surname: [
        'Please enter your last name.'
    ],
    email: [
        'Please type a valid email address',
        'Please type a valid email address.'
    ],
    phone: [
        'Please type a valid phone number.'
    ],
    acceptTerms: [
        'Please accept terms & conditions'
    ],
    acceptPrivacy: [
        'Please accept Privacy Policy'
    ],
    reCaptchaResponse: [
        'ReCAPTCHA required'
    ]
}

*/

function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        errors: state.errors
    }
}


function mapDispatchToProps(dispatch, props){
    return {
        actions:{
            ...props.actions,
            errors: bindActionCreators(errorsActions, dispatch)
        }
    }
}


export function withErrors(Wrapped){

    return connect(mapStateToProps, mapDispatchToProps)(Wrapped)

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/errors/index.tsx